import { AssociateCompanyTable } from '../../../../companyAnalysis/ownershipAndGroup/associateCompanies/AssociateCompanyTable'
import { BranchTable } from '../../../../companyAnalysis/ownershipAndGroup/branches/BranchTable'
import { OwnershipStructureTable } from '../../../../companyAnalysis/ownershipAndGroup/ownershipStructure/OwnershipStructureTable'
import { OwnershipType } from '../../../../companyAnalysis/ownershipAndGroup/ownershipStructure/OwnershipType'
import { ShareHolder } from '../../../../companyAnalysis/ownershipAndGroup/ownershipStructure/ShareHolder'
import { ParentCompanyTable } from '../../../../companyAnalysis/ownershipAndGroup/parentCompany/ParentCompanyTable'
import { RelatedCompanyTable } from '../../../../companyAnalysis/ownershipAndGroup/relatedCompany/RelatedCompanyTable'
import {
  getOwnershipDetail,
  getOwnershipTypes,
  getRelatedCompanyViewBy,
} from '../../../../companyAnalysis/ownershipAndGroup/store/thunk'
import { SubsidiaryTable } from '../../../../companyAnalysis/ownershipAndGroup/subsidiaries/SubsidiaryTable'
import { getUnique } from '../../../../helpers/common'
import {
  MAIN_SCREEN,
  SCREEN,
  TYPE_INFORMATION_PANEL,
  TYPE_ITEM_SETTING,
  VIEW_BY,
} from '../../constant'

const PANELS = {
  OWNERSHIP_STRUCTURE: 'ownershipStructure',
  PARENT_COMPANIES: 'parentCompanies',
  BRANCHES: 'branches',
  SUBSIDIARIES: 'subsidiaries',
  ASSOCIATES: 'associates',
  RELATED_COMPANIES: 'relatedCompanies',
}

export const getPanelListOwnershipAndGroup = () => {
  return [
    {
      label: 'dynamicReport.OWNERSHIP_AND_GROUP',
      children: [
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].OWNERSHIP_AND_GROUP,
          panel: PANELS.OWNERSHIP_STRUCTURE,
          label: 'dynamicReport.OWNERSHIP_STRUCTURE',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            check: ['hasMajorShareHolders', 'hasOwnershipTypes'],
            viewBy: VIEW_BY.TABLE,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].OWNERSHIP_AND_GROUP,
          panel: PANELS.PARENT_COMPANIES,
          label: 'dynamicReport.PARENT_COMPANIES',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].OWNERSHIP_AND_GROUP,
          panel: PANELS.BRANCHES,
          label: 'dynamicReport.BRANCHES',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].OWNERSHIP_AND_GROUP,
          panel: PANELS.SUBSIDIARIES,
          label: 'dynamicReport.SUBSIDIARIES',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].OWNERSHIP_AND_GROUP,
          panel: PANELS.ASSOCIATES,
          label: 'dynamicReport.ASSOCIATES',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].OWNERSHIP_AND_GROUP,
          panel: PANELS.RELATED_COMPANIES,
          label: 'dynamicReport.RELATED_COMPANIES',
          type: TYPE_ITEM_SETTING.PANEL,
        },
      ],
    },
  ]
}

export const getPanelOwnershipAndGroup = (panel, { viewBy, check }) => {
  switch (panel) {
    case PANELS.OWNERSHIP_STRUCTURE: {
      return {
        renderComponent: () => {
          return viewBy === VIEW_BY.TABLE ? (
            <OwnershipStructureTable isDynamicReport />
          ) : (
            <div className="dFlex">
              {check.includes('hasMajorShareHolders') && <ShareHolder />}
              {check.includes('hasOwnershipTypes') && <OwnershipType />}
            </div>
          )
        },
        thunk: [
          () => getOwnershipTypes(),
          ({ companyInfo }) =>
            getOwnershipDetail({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: viewBy === VIEW_BY.TABLE,
        isTable: true,
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.CHART],
          [VIEW_BY.CHART]: [
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              key: 'check',
              value: 'hasMajorShareHolders',
              title: 'companyAnalysis.ownershipAndGroup.MAJOR_SHAREHOLDERS',
            },
            {
              type: TYPE_INFORMATION_PANEL.CHECKBOX,
              key: 'check',
              value: 'hasOwnershipTypes',
              title: 'companyAnalysis.ownershipAndGroup.OWNERSHIP_TYPES',
            },
          ],
        },
      }
    }
    case PANELS.PARENT_COMPANIES: {
      return {
        renderComponent: () => {
          return <ParentCompanyTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo }) =>
            getOwnershipDetail({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    }
    case PANELS.BRANCHES: {
      return {
        renderComponent: () => {
          return <BranchTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo }) =>
            getOwnershipDetail({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    }
    case PANELS.SUBSIDIARIES: {
      return {
        renderComponent: () => {
          return <SubsidiaryTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo }) =>
            getOwnershipDetail({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    }
    case PANELS.ASSOCIATES: {
      return {
        renderComponent: () => {
          return <AssociateCompanyTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo }) =>
            getOwnershipDetail({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    }
    case PANELS.RELATED_COMPANIES: {
      return {
        renderComponent: () => {
          return <RelatedCompanyTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo }) =>
            getOwnershipDetail({
              organizationId: companyInfo.organizationId,
            }),
          ({ companyInfo }) =>
            getRelatedCompanyViewBy({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    }
    default:
      break
  }
}

export const getDefaultOwnershipAndGroup = () => {
  return getPanelListOwnershipAndGroup()[0].children.map((panel) => ({
    id: getUnique(),
    ...panel,
  }))
}
